// extracted by mini-css-extract-plugin
module.exports = {"newsletterForm":"Newsletter_newsletterForm__BiwY5"};